// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-CompanyDetails-ExpenseExportModels___card--flIVi {
  max-width: 736px;
  margin: 0 0 30px;
  padding: 32px;
  box-sizing: border-box;
  overflow: hidden;
}

.components-CompanyDetails-ExpenseExportModels___card--flIVi h2 {
  margin: 0 0 10px;
  font-weight: 600;
}

.components-CompanyDetails-ExpenseExportModels___card--flIVi .components-CompanyDetails-ExpenseExportModels___tableContainer--E_Vb7 {
  overflow: scroll
}

.components-CompanyDetails-ExpenseExportModels___card--flIVi td,
.components-CompanyDetails-ExpenseExportModels___card--flIVi th {
  padding-left: 0;
  color: #1b2432;
  font-size: 15px;
  overflow-wrap: break-word;
  word-break: break-word;
}

.components-CompanyDetails-ExpenseExportModels___clickableRow--_4Kdb {
  cursor: pointer;
}

.components-CompanyDetails-ExpenseExportModels___loader--OtyUO {
  min-height: 48px;
  position: relative;
}

.components-CompanyDetails-ExpenseExportModels___empty--P0NBU {
  color: #687282;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./components/CompanyDetails/ExpenseExportModels.pcss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;AACF;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAGA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB","sourcesContent":[".card {\n  max-width: 736px;\n  margin: 0 0 30px;\n  padding: 32px;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.card h2 {\n  margin: 0 0 10px;\n  font-weight: 600;\n}\n\n.card .tableContainer {\n  overflow: scroll\n}\n\n.card td,\n.card th {\n  padding-left: 0;\n  color: #1b2432;\n  font-size: 15px;\n  overflow-wrap: break-word;\n  word-break: break-word;\n}\n\n.clickableRow {\n  cursor: pointer;\n}\n\n\n.loader {\n  min-height: 48px;\n  position: relative;\n}\n\n.empty {\n  color: #687282;\n  font-size: 14px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `components-CompanyDetails-ExpenseExportModels___card--flIVi`,
	"tableContainer": `components-CompanyDetails-ExpenseExportModels___tableContainer--E_Vb7`,
	"clickableRow": `components-CompanyDetails-ExpenseExportModels___clickableRow--_4Kdb`,
	"loader": `components-CompanyDetails-ExpenseExportModels___loader--OtyUO`,
	"empty": `components-CompanyDetails-ExpenseExportModels___empty--P0NBU`
};
module.exports = ___CSS_LOADER_EXPORT___;
